import { useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    counterContainer: {
      display: "flex",
      justifyContent: "flex-end",
    },
    charsCounter: {
      color: "#777",
      fontSize: 13,
      marginRight: "0.5em",
    },
    overflow: {
      fontWeight: "bold",
      color: "red",
    },
  }),
);

const useInputLengthCounter = (maxChars: number, currentCount: number) => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => ({}), []);
  const atomicStyles = useAtomicStyles();

  const displayText = useMemo(() => `${currentCount} / ${maxChars}`, [
    maxChars,
    currentCount,
  ]);

  return {
    styles,
    classes,
    atomicStyles,
    displayText,
  };
};

export { useInputLengthCounter as default };
